// extracted by mini-css-extract-plugin
export default {"circleContentHolder":"ImpactCircle_circleContentHolder__Vywk0","circleTextHolder":"ImpactCircle_circleTextHolder__FVARk"};